/** @format */
import angular from 'angular';
export const l10nModule = 'sis-common.l10n';
(function () {
  angular.module(l10nModule, ['sis-common.l10n.localeService', 'sis-common.l10n.localizedStringFilter', 'sis-common.l10n.formErrorTranslateFilter']);
})();